module.exports = __webpack_public_path__ + "img/waf.6461622.svg";